export const BadgeUnlockEffect = ({ showBadgeUnlock, newlyUnlockedBadge }) => {
  if (!showBadgeUnlock || !newlyUnlockedBadge) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none overflow-hidden">
      {/* Screen Flash */}
      <div
        className="absolute inset-0 animate-levelup-flash"
        style={{
          background: 'linear-gradient(45deg, #a855f7, #ec4899)',
          mixBlendMode: 'screen'
        }}
      />

      {/* Badge Display - Centered and Fixed */}
      <div className="relative w-full max-w-4xl px-4 animate-levelup-shake">
        <div className="animate-badge-zoom-fixed">
          <div className={`${newlyUnlockedBadge.bgColor} border-4 sm:border-8 border-black px-6 sm:px-12 py-6 sm:py-8 shadow-2xl mx-auto relative`}
            style={{
              filter: 'drop-shadow(0 0 40px rgba(168, 85, 247, 0.8))'
            }}>
            <div className="text-center relative z-10">
              <div className="text-4xl sm:text-6xl md:text-8xl font-black mb-3 sm:mb-4 text-white animate-pulse">
                BADGE UNLOCKED!
              </div>
              <div className="text-6xl sm:text-8xl md:text-9xl mb-4">
                {newlyUnlockedBadge.icon}
              </div>
              <div className={`text-3xl sm:text-5xl md:text-7xl font-black ${newlyUnlockedBadge.color} uppercase tracking-wider mb-2 break-words`}>
                {newlyUnlockedBadge.name}
              </div>
              <div className="text-lg sm:text-2xl md:text-4xl font-black text-white/80">
                {newlyUnlockedBadge.description}
              </div>
            </div>

            {/* Glow effect behind badge */}
            <div
              className="absolute inset-0 blur-3xl opacity-70 -z-10"
              style={{
                background: 'radial-gradient(circle, rgba(168, 85, 247, 0.8), rgba(236, 72, 152, 0.6))'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
